import { axios } from '@/utils/request'

/**
 * 统计接诊量
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function statisticsVisit (parameter) {
  return axios({
    url: '/count/getVisit',
    method: 'get',
    params: parameter
  })
}

/**
 * 获取科室
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function statisticsDept (parameter) {
  return axios({
    url: '/dept/getDeptList',
    method: 'get',
    params: parameter
  })
}


/**
 * 获取列表数据
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function statisticsList (parameter) {
  return axios({
    url: '/count/getVisitList',
    method: 'get',
    params: parameter
  })
}


/**
 * 添加处方审核
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function recipeAdd (parameter) {
  return axios({
    url: '/checkrecipe/add',
    method: 'post',
    data: parameter
  })
}


